import StatementSummaryTable from "@bToC/Components/StatementSummaryTable";
import { GetStatementLinesApiParameter } from "@bToC/Services/StatementService";
import loadStatementLines from "@bToC/Store/Data/StatementLines/Handlers/LoadStatementLines";
import { getStatementLines } from "@bToC/Store/Data/StatementLines/StatementLinesSelector";
import updateLineSearchFields from "@bToC/Store/Pages/StatementDetails/Handlers/UpdateLineSearchFields";
import { CustomState } from "@bToC/Store/Reducers";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomState) => ({
    settings: getSettingsCollection(state),
    statementLinesData: getStatementLines(state),
    getStatementLinesParameter: state.customPagesReducer.statementDetails.getStatementLinesParameter,
    location: getLocation(state),
});

const mapDispatchToProps = {
    loadStatementLines,
    updateLineSearchFields,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

export interface StatementDetailsSummaryTableStyles {
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
}

export const statementSummaryTableStyles: StatementDetailsSummaryTableStyles = {
    centeringWrapper: {
        css: css`
            height: 300px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
};

const styles = statementSummaryTableStyles;

const StatementDetailsSummaryTable = ({
    updateLineSearchFields,
    location,
    loadStatementLines,
    getStatementLinesParameter,
    statementLinesData,
}: Props) => {
    const getStatementLinesApiParameter = parseQueryString<GetStatementLinesApiParameter>(location.search);
    const statementNumber = getStatementLinesApiParameter.statementNumber;
    useEffect(() => {
        updateLineSearchFields({ ...getStatementLinesApiParameter });
    }, [location.search]);

    useEffect(() => {
        if (!statementLinesData.isLoading) {
            loadStatementLines({ ...getStatementLinesParameter, statementNumber });
        }
    }, [getStatementLinesParameter]);

    if (statementLinesData?.isLoading || !statementLinesData?.dataLoaded) {
        return (
            <StyledWrapper {...styles.centeringWrapper}>
                <LoadingSpinner {...styles.spinner} />
            </StyledWrapper>
        );
    }
    return (
        <>
            <StatementSummaryTable 
                statementLinesData={statementLinesData} 
                getStatementLinesParameter={getStatementLinesParameter} 
                updateLineSearchFields={updateLineSearchFields}/>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withHistory(connect(mapStateToProps, mapDispatchToProps)(StatementDetailsSummaryTable)),
    definition: {
        group: "Basic",
        displayName: "Statement Summary Table",
    },
};

export default widgetModule;
